import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EditorTabAlert({
  reset
}) {
  return /*#__PURE__*/_jsx(Alert, {
    inlineSize: "100%",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.tabbed-editor.editor-tab-alert.title"
    }),
    type: "danger",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.tabbed-editor.editor-tab-alert.text"
      }), /*#__PURE__*/_jsx(Button, {
        size: "extra-small",
        use: "tertiary",
        onClick: reset,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.tabbed-editor.editor-tab-alert.reset-button"
        })
      })]
    })
  });
}
EditorTabAlert.displayName = 'EditorTabAlert';